import { setTag } from "service/mapper";
import { apiPost } from "../baseApi";

export const create = async (data) => {
  try {
    const response = await apiPost("_tag", data);
    return { ...response,data:setTag(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
